import React from 'react';
import { Card } from 'react-bootstrap';
import ApexChart from 'react-apexcharts';
import { FaChartBar } from 'react-icons/fa'; // 👈 React Icon here

const MainBarChart = ({ data, title }) => {
 const chartOptions = {
  chart: {
    type: 'bar',
    toolbar: { show: false },
    fontFamily: 'inherit',
  },
  colors: ['#4e79a7'], // Modern base color
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'light',
      type: 'vertical',
      shadeIntensity: 0.25,
      gradientToColors: ['#ba5419ff'], // Target gradient color
      inverseColors: false,
      opacityFrom: 0.9,
      opacityTo: 1,
      stops: [0, 100],
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 6,
      columnWidth: '45%',
      endingShape: 'rounded',
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '12px',
      fontWeight: 600,
      colors: ['#ffffff'],
    },
    formatter: (val) => val,
    offsetY: -4,
  },
  grid: {
    borderColor: '#e0e0e0',
    strokeDashArray: 3,
  },
  xaxis: {
    categories: data.map((item) => item.name),
    labels: {
      style: { fontSize: '12px' },
    },
  },
  yaxis: {
    labels: {
      style: { fontSize: '12px' },
    },
  },
  tooltip: {
    theme: 'light',
  },
};


  const chartSeries = [
    {
      name: 'Count',
      data: data.map((item) => item.count),
    },
  ];

  return (
    <Card
      className="border-0 shadow-sm h-100 rounded-4"
      style={{
        background: 'linear-gradient(145deg, #007bff10, #007bff02)',
        backdropFilter: 'blur(2px)',
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.04)';
      }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold text-dark mb-0">{title}</h5>
          <FaChartBar size={20} className="text-primary" />
        </div>

        <ApexChart
          options={chartOptions}
          series={chartSeries}
          type="bar"
          height={300}
        />
      </Card.Body>
    </Card>
  );
};
export default MainBarChart;
